module.exports = __webpack_public_path__ + "img/ICSR_2023.a6366c7d.png";